// extracted by mini-css-extract-plugin
module.exports = {"counterpart":"az_T8c","alignEachItemPriceWithError":"az_U8c","unitPrice":"az_V8c","cartClass":"az_W8c","mxCart":"az_X8c","quantityAvailableError":"az_Y8c"};